var map = {
	"./classify_img1.png": "41fb",
	"./classify_img2.png": "090b",
	"./classify_img3.png": "8537",
	"./classify_img4.png": "8664",
	"./classify_img5.png": "3a29",
	"./classify_img6.png": "74ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0080";